const CONSTANTS = {
  ON_AUTH_LOADING: "auth/ON_AUTH_LOADING",
  ON_AUTH_LOGIN: "auth/ON_AUTH_LOGIN",
  ON_AUTH_LOGOUT: "auth/ON_AUTH_LOGOUT",
  ON_AUTH_REGISTER: "auth/ON_AUTH_REGISTER"
};

export { CONSTANTS };
